import { useQuotation } from "../context/QuotationContext";

const DEFAULT_NAVBAR =
  "relative bg-brand-primary text-white px-8 py-3 rounded-full text-xs font-bold uppercase tracking-widest hover:brightness-110 hover:shadow-[0_10px_20px_rgba(0,0,0,0.1)] transition-all active:scale-95";

const DEFAULT_MOBILE =
  "relative w-full mt-4 bg-brand-primary text-white py-5 rounded-2xl text-center font-bold shadow-lg";

const DEFAULT_ICON =
  "relative flex items-center justify-center rounded-2xl bg-white/80 p-2 transition-all duration-200 hover:bg-[#658b10]/5";

const QuotationCartButton = ({
  className = "",
  buttonClassName,
  variant = "navbar",
  label = "Cotizar",
  onBeforeOpen,
  children,
}) => {
  const { itemCount, openDrawer } = useQuotation();

  const handleClick = () => {
    onBeforeOpen?.();
    openDrawer();
  };

  const variantClass =
    buttonClassName ||
    (variant === "mobile-menu" ? DEFAULT_MOBILE : variant === "icon" ? DEFAULT_ICON : DEFAULT_NAVBAR);

  const badgeIcon =
    "absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-accent text-brand-dark text-[10px] font-black flex items-center justify-center shadow-md border-2 border-white";

  const badgeNavbar =
    "absolute -top-2 -right-2 min-w-[20px] h-[20px] px-1 rounded-full bg-brand-accent text-brand-dark text-[10px] font-black flex items-center justify-center shadow-md border-2 border-white";

  const badgeMobile =
    "ml-2 inline-flex min-w-[22px] h-[22px] px-1.5 rounded-full bg-white/20 text-white text-[11px] font-black items-center justify-center";

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${variantClass} ${className}`}
      aria-label={`Cotizar, ${itemCount} servicios en el carrito`}
    >
      {children ?? (variant !== "icon" ? label : null)}
      {itemCount > 0 && (
        <span
          className={
            variant === "icon" ? badgeIcon : variant === "mobile-menu" ? badgeMobile : badgeNavbar
          }
          aria-live="polite"
        >
          {itemCount}
        </span>
      )}
    </button>
  );
};

export default QuotationCartButton;
